import { useDispatch, useSelector } from 'react-redux'
import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { fetchCollegeData } from '../redux/slice/collegePage'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import OurPeopleDialogue from '../components/colleges/ourPeopleDialogue'
import About from '../components/colleges/about'
import AboutSection from '../components/colleges/aboutSection'
import DepartmentSection from '../components/colleges/departmentSection'
import ScrollContainer from 'react-indiana-drag-scroll'
import ResearchSection from '../components/colleges/researchSection'
import ResearchExpertise from '../components/colleges/researchExpertise'
import NewsSection from '../components/colleges/newsSection'
import GAC from '../components/colleges/gAC'
import ServicesSection from '../components/colleges/servicesSection'
import TabsPage from './tabsPage'

const NewCollege = () => {
  const dispatch = useDispatch()

  // const [searchParams] = useSearchParams()
  const { name: collegeName } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )
  const defaultActiveTab = parseInt(queryParams.get('tab')) || 0
  const [activeTab, setActiveTab] = useState(defaultActiveTab)
  useEffect(() => {
    if (collegeName) {
      dispatch(fetchCollegeData(collegeName))
    }
  }, [dispatch, collegeName])
  const state = useSelector(state => state.college)

  const college = state?.data?.properties

  const title = college?.title
  const bg =
    college?.backgroundImage != null
      ? retrunAssets(college?.backgroundImage[0]?.url)
      : returnNotImage()

  const collegeTabs = [
    {
      header: 'About Us',
      content: <AboutSection college={college} />
    },
    {
      header: 'Our People',
      content: <OurPeopleDialogue id={college?.collegeId} title={title} />
    },
    {
      header: 'Departments',
      content: <DepartmentSection college={college} />
    },
    {
      header: 'Services',
      content: <ServicesSection college={college} />
    },
    {
      header: 'News & Updates',
      content: <NewsSection college={college} />
    },
    {
      header: 'Research',
      content:
        collegeName == 'uniten-business-school-ubs' ? (
          <ResearchExpertise college={college} />
        ) : (
          <ResearchSection college={college} />
        )
    },
    {
      header: 'Student Guide',
      content: (
        <Navigate to={location.pathname + '/cogs-student-guide'} replace />
      )
    },
    {
      header: 'GAC',
      content: <GAC college={college} />
    }
  ]
  // filter to show Student Guide tab only for COGS
  const filteredTabs = collegeName.includes('college-of-graduate-studies-cogs')
    ? collegeTabs.filter(
        tab => tab.header !== 'News & Updates' && tab.header !== 'Research' && tab.header !== 'Services'
      )
    : 
    collegeName.includes('college-of-continuing-education-cced') ?

    collegeTabs.filter(
        tab => tab.header !== 'Student Guide' && tab.header !== 'GAC'
      ):
    collegeTabs.filter(
        tab => tab.header !== 'Student Guide' && tab.header !== 'GAC'  && tab.header !== 'Services'
      )


  const handleTabClick = index => {
    setActiveTab(index)
    queryParams.set('tab', index)
    navigate({ search: queryParams.toString() })
  }

  return (
    // <AnimatedPage>
    //   <Banner text={title} bg={bg} />
    //   <div className='w-full max-w-8xl my-4 flex items-center justify-center gap-8'>
    //     <ScrollContainer
    //       horizontal
    //       className='flex gap-3 lg:gap-5   scroll-smooth snap-mandatory snap-x overflow-x-auto  px-2 scroll-px-3 '
    //       role='tablist'
    //     >
    //       {filteredTabs?.map((tab, index) => (
    //         <button
    //           key={index}
    //           className={`whitespace-nowrap shrink-0 snap-center ${
    //             activeTab === index ? 'text-[#000000]' : 'text-[#747474]'
    //           } text-lg font-semibold border-b-4 px-4 pb-1 transition-all ${
    //             activeTab === index ? 'border-[#FF4D4D]' : 'border-transparent'
    //           }`}
    //           onClick={() => handleTabClick(index)}
    //         >
    //           {tab.header}
    //         </button>
    //       ))}
    //     </ScrollContainer>
    //   </div>
    //   <div className='w-full flex items-center justify-center my-8'>
    //     <div className='w-full flex items-center justify-center'>
    //       {filteredTabs[activeTab]?.content}
    //     </div>
    //   </div>
    // </AnimatedPage>
    <TabsPage title={title} bg={bg} tabs={filteredTabs}/>
  )
}

export default NewCollege
